import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "width",
      description: "MessageBox宽度",
      type: "String",
      default: "360px"
    },
    {
      prop: "title",
      description: "MessageBox标题",
      type: "String"
    },
    {
      prop: "message",
      description: "MessageBox正文内容",
      type: "String"
    },
    {
      prop: "type",
      description:
        "MessageBox类型，为alert/confirm/prompt，不需传入，根据调用方法确定",
      type: "String"
    },
    {
      prop: "showHeader",
      description: "MessageBox是否展示头部（含标题和图标）",
      type: "Boolean",
      default: "alert为true, 其他为false"
    },
    {
      prop: "confirmText",
      description: "MessageBox确定按钮文本",
      type: "String",
      default: "确定"
    },
    {
      prop: "cancelText",
      description: "MessageBox取消按钮文本",
      type: "String",
      default: "取消"
    },
    {
      prop: "onClose",
      description:
        "MessageBox关闭回调，在确定和取消时都会调用确定时含有参数({inputValue}, {instance})",
      type: "Function"
    },
    {
      prop: "onCloseConfirmText",
      description: "MessageBox调用关闭回调时确定按钮显示的文本",
      type: "String",
      default: "确定"
    },
    {
      prop: "resolve",
      description: "MessageBox确定回调",
      type: "Function"
    },
    {
      prop: "reject",
      description: "MessageBox取消回调",
      type: "Function"
    },
    {
      prop: "input",
      description: "prompt模式MessageBox input内容，用作置初值",
      type: "String"
    },
    {
      prop: "placeholder",
      description: "prompt模式MessageBox placeholder属性值",
      type: "String"
    },
    {
      prop: "validator",
      description: "prompt模式MessageBox input验证方法",
      type: "Function"
    },
    {
      prop: "btnDisabled",
      description: "MessageBox按钮是否禁用，用于防止重复点击",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
